// extracted by mini-css-extract-plugin
export default {"sectionFive":"SectionFive_sectionFive__gkaIN"};